/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCompanyDeliveryHoursInfoQueryVariables = Exact<{
  companyId: string;
}>;


export type GetCompanyDeliveryHoursInfoQuery = { company_by_pk: { delivery_description: string | null, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }> } | null };


export const GetCompanyDeliveryHoursInfoDocument = /*#__PURE__*/ gql`
    query GetCompanyDeliveryHoursInfo($companyId: uuid!) {
  company_by_pk(id: $companyId) {
    delivery_description
    delivery_hours {
      id
      opening_hour
      closing_hour
      week_day
    }
  }
}
    `;

/**
 * __useGetCompanyDeliveryHoursInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyDeliveryHoursInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDeliveryHoursInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDeliveryHoursInfoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyDeliveryHoursInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables> & ({ variables: GetCompanyDeliveryHoursInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>(GetCompanyDeliveryHoursInfoDocument, options);
      }
export function useGetCompanyDeliveryHoursInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>(GetCompanyDeliveryHoursInfoDocument, options);
        }
// @ts-ignore
export function useGetCompanyDeliveryHoursInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>;
export function useGetCompanyDeliveryHoursInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDeliveryHoursInfoQuery | undefined, GetCompanyDeliveryHoursInfoQueryVariables>;
export function useGetCompanyDeliveryHoursInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>(GetCompanyDeliveryHoursInfoDocument, options);
        }
export type GetCompanyDeliveryHoursInfoQueryHookResult = ReturnType<typeof useGetCompanyDeliveryHoursInfoQuery>;
export type GetCompanyDeliveryHoursInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyDeliveryHoursInfoLazyQuery>;
export type GetCompanyDeliveryHoursInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDeliveryHoursInfoSuspenseQuery>;
export type GetCompanyDeliveryHoursInfoQueryResult = Apollo.QueryResult<GetCompanyDeliveryHoursInfoQuery, GetCompanyDeliveryHoursInfoQueryVariables>;